import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import Home from './views/Home'

const Dashboard = () => import(/* webpackChunkName: "dashboard" */'@/views/Dashboard')
const Media = () => import(/* webpackChunkName: "media" */'@/views/Media')
const Adspot = () => import(/* webpackChunkName: "adspot" */'@/views/Adspot')
const Supplier = () => import(/* webpackChunkName: "supplier" */'@/views/Supplier')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: Home,

      children: [
        {
          path: '/',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/media',
          name: 'media',
          component: Media
        },
        {
          path: '/adspot',
          name: 'adspot',
          component: Adspot
        },
        {
          path: '/supplier',
          name: 'supplier',
          component: Supplier
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/login') {
    next()
  } else if (Vue.prototype.checkToken()) {
    next()
  } else {
    next('/login')
  }
})

export default router
